module.exports = __webpack_public_path__ + "img/china.49416fe7.png";